/**
 * Created by Ivan on 26.05.2025
 */

const ComboTutorial = function () {
    return new TutorialScenario(ComboTutorial.NAME, {
        listSteps: () => [
            ComboTutorial.createStrikeStep()
        ],

        onStart: function () {
            Game.currentGame.shownTutorials.push(ComboTutorial.NAME);

            cleverapps.focusManager.showControlsWhileFocused(["comboBar"]);
        },

        isAvailable: () => Game.currentGame
            && !Game.currentGame.shownTutorials.includes(ComboTutorial.NAME)
            && cleverapps.user.checkAvailable(cleverapps.config.availables.COMBO_TUTORIAL)
    });
};

ComboTutorial.createStrikeStep = () => new TutorialStep({
    onStart: function () {
        const target = cleverapps.Scenes.GetSceneComponent(TriPeaksSceneComponent).comboBarControl;

        this.force = cleverapps.forces.create(target, {
            text: "BonusTutorialMessage",
            finger: true
        });

        cleverapps.forces.onceForceClosed = this.finish.bind(this);
    },

    onFinish: function () {
        cleverapps.tutorial.startNextStep();
    }
});

ComboTutorial.NAME = "combo";
ComboTutorial.STRIKE_CONFIG = {
    force: "BonusTutorialMessage"
};
